import { Injectable } from '@angular/core';
import { AppSettings } from './settings';
import { EstadoModel } from '../models/estado-model';
import { HttpClient, HttpHeaders } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class EstadosService {
  private rutaApi:string = AppSettings.apiEndpoint;
  private path:string = "";
  private produccion:boolean = AppSettings.produccion;
  public response: any;

  constructor(private http: HttpClient) { }

  async consulEst () {
    if(this.produccion){ this.path = this.rutaApi+'consultar_estado.php';}
    else { this.path = '/api/consulEst'; }

    const params={
    }

    const headers = new HttpHeaders({ 'Content-Type': 'application/json'}); //T0D0 GENERALIZAR
    let response = await this.http.post<EstadoModel>(this.path,params,{headers}).toPromise();
    
        return  response;




   }
}
